import React, { Suspense } from "react";
import { Switch, Redirect } from "react-router-dom";
import { SplashScreen } from "../../../_metronic/_partials/controls";
import { ContentRoute } from "../../../_metronic/layout";
import BasicInformation from "./Applicant/BasicInformation/Index";
import TrainingNSpecialization from "./Applicant/TrainingNSpecialization";
import AdditionalInformation from "./Applicant/AdditionalInformation";
import EducationInfo from "./Applicant/Education";
import ProfessionInfo from "./Applicant/Profession";
import ResearchNPublication from "./Applicant/ResearchNPublication";

export default function MannualApplicantPage() {
  return (
    <Suspense fallback={<SplashScreen />}>
      <Switch>
        <ContentRoute
          exact
          path="/public-applicant/basic-info/"
          component={BasicInformation}
        />
        <ContentRoute
          exact
          path="/public-applicant/basic-info/:id"
          component={BasicInformation}
        />
        <ContentRoute
          exact
          path="/public-applicant/educational-info/:id"
          component={EducationInfo}
        />
        <ContentRoute
          exact
          path="/public-applicant/experience-info/:id"
          component={ProfessionInfo}
        />
        <ContentRoute
          exact
          path="/public-applicant/resarch-publication/:id"
          component={ResearchNPublication}
        />
        <ContentRoute
          exact
          path="/public-applicant/training-specialization/:id"
          component={TrainingNSpecialization}
        />
        <ContentRoute
          exact
          path="/public-applicant/additional-information/:id"
          component={AdditionalInformation}
        />
      </Switch>
    </Suspense>
  );
}
